<div class="container">
  <div class="action-header space-between row w100 gap-24">
    <div class="row gap-8">
      <rr-btn
        size="small"
        type="Secondary"
        *ngIf="!isEditing"
        iconStart="miro"
        (click)="miroExport()"
        >Miro Export</rr-btn
      >
      <rr-btn
        size="small"
        type="Secondary"
        *ngIf="!isEditing"
        iconStart="pdf"
        (click)="downloadAsPdf()"
        >Download PDF</rr-btn
      >
    </div>
    <div class="row gap-8">
      <rr-btn
        size="small"
        (btnclick)="toggleEdit()"
        type="Secondary"
        [iconStart]="isEditing ? 'check' : 'edit'"
        >{{ isEditing ? "Save" : "Edit" }}</rr-btn
      >
      <rr-btn
        iconStart="close"
        size="small"
        type="Secondary"
        (btnclick)="close()"
        >{{ isEditing ? "Cancel" : "Close" }}</rr-btn
      >
    </div>
  </div>
  <div class="preview">
    <div class="preview-header">
      <img src="images/logo_name.svg" />
      <h2>{{ data.name }}</h2>
    </div>
    <div class="preview-content">
      <div [formGroup]="form">
        <ng-container
          *ngTemplateOutlet="renderForm; context: { control: form }"
        ></ng-container>
      </div>
      <ng-template #renderForm let-control="control">
        <!-- FormGroup -->
        <div *ngIf="isFormGroup(control)">
          <div *ngFor="let item of control.controls | keyvalue : originalOrder">
            @if( item.key !== "id" && item.key !== "name" && item.key !==
            "created" && item.key !== "image" ){
            <h3 *ngIf="isFormGroup(control.get(item.key))">
              {{ keyToHeading(item.key) }}
            </h3>
            <h4 *ngIf="!isFormGroup(control.get(item.key))">
              {{ keyToHeading(item.key) }}
            </h4>

            <ng-container
              class="w100"
              *ngTemplateOutlet="
                renderForm;
                context: { control: control.get(item.key) }
              "
            ></ng-container>
            }
          </div>
        </div>

        <!-- FormArray -->
        <ul *ngIf="isFormArray(control)" class="w100 col">
          <li *ngFor="let c of control.controls" class="w100">
            <ng-container
              *ngTemplateOutlet="renderForm; context: { control: c }"
              class="w100"
            ></ng-container>
          </li>
        </ul>

        <!-- FormControl -->
        <div *ngIf="isFormControl(control)" class="w100">
          <!-- Show input if editing -->
          <rr-textarea
            *ngIf="isEditing"
            [FormControl]="control"
            [class.edited]="control.dirty"
            [attr.placeholder]="'Edit value'"
            [fitText]="true"
            class="w100"
          />

          <!-- Show plain text if not editing -->
          <p *ngIf="!isEditing">{{ control.value }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
